import React from 'react';
import './style.css';

// eslint-disable-next-line react/prop-types
export default ({ className }) => (
  <div className={`${className} divider`} />
);
